<div class="fh-modal" role="dialog" aria-modal="true" aria-labelledby="service-modal-title">
  <div class="fh-modal-backdrop" (click)="closed.emit()"></div>
  <div class="fh-modal-panel">
    <div class="fh-modal-head">
      <span *ngIf="isEdit" class="line-tile" [ngClass]="areas[lineOf(service!.businessLine).area].tone">
        <i class="bi" [ngClass]="lineOf(service!.businessLine).icon"></i>
      </span>
      <span *ngIf="!isEdit" class="line-tile tone-medicina"><i class="bi bi-plus-lg"></i></span>
      <div class="flex-grow-1 min-w-0">
        <div class="small text-muted-fh">{{ company.name }}</div>
        <h2 id="service-modal-title" class="h5 fw-semibold mb-0 text-truncate">
          {{ isEdit ? service!.name : 'Aggiungi servizio' }}
        </h2>
        <div *ngIf="isEdit" class="small text-muted-fh">Servizio #{{ service!.id }}</div>
      </div>
      <button type="button" class="icon-btn" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="fh-modal-body">
      <div *ngIf="!isEdit" class="segmented mb-4">
        <button type="button" [class.active]="mode === 'create'" (click)="setMode('create')">
          <i class="bi bi-plus-circle me-1"></i>Nuovo servizio
        </button>
        <button type="button" [class.active]="mode === 'link'" (click)="setMode('link')">
          <i class="bi bi-link-45deg me-1"></i>Collega esistente
        </button>
      </div>

      <!-- Nuovo / modifica -->
      <form *ngIf="mode === 'create' || isEdit" [formGroup]="form" (ngSubmit)="submit()" class="row g-3">
        <div class="col-12">
          <label class="form-label" for="svc-name">Nome</label>
          <input id="svc-name" class="form-control" formControlName="name" placeholder="Es. Babysitter – {{ company.name }}" />
          <span class="form-error" *ngIf="(form.get('name')?.touched || formInvalid) && form.get('name')?.invalid">
            Questo campo è obbligatorio
          </span>
        </div>
        <div class="col-sm-7">
          <label class="form-label" for="svc-line">Business line</label>
          <select id="svc-line" class="form-select" formControlName="businessLine">
            <option [ngValue]="null" disabled>Seleziona</option>
            <optgroup *ngFor="let group of lineOptions" [label]="group.label">
              <option *ngFor="let line of group.lines" [ngValue]="line">{{ lines[line].label }}</option>
            </optgroup>
          </select>
          <span class="form-error" *ngIf="(form.get('businessLine')?.touched || formInvalid) && form.get('businessLine')?.invalid">
            Questo campo è obbligatorio
          </span>
        </div>
        <div class="col-sm-5">
          <label class="form-label" for="svc-customer">Tipo cliente</label>
          <select id="svc-customer" class="form-select" formControlName="customerType">
            <option *ngFor="let type of customerTypes" [ngValue]="type">{{ type }}</option>
          </select>
        </div>
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2">
            <div>
              <div class="fw-medium small">Servizio attivo</div>
              <div class="hint">Se disattivato i dipendenti non possono richiederlo</div>
            </div>
            <div class="form-check form-switch m-0">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="active" aria-label="Servizio attivo" />
            </div>
          </div>
        </div>
        <div class="col-12">
          <label class="form-label" for="svc-script">Script <span class="hint">(facoltativo)</span></label>
          <textarea id="svc-script" class="form-control" rows="3" formControlName="script"></textarea>
          <span class="hint">Per la formattazione usa la scheda completa del servizio.</span>
        </div>
      </form>

      <!-- Collega esistente -->
      <div *ngIf="mode === 'link' && !isEdit">
        <div class="position-relative mb-3">
          <i class="bi bi-search position-absolute top-50 translate-middle-y ms-3 text-muted-fh"></i>
          <input class="form-control ps-5" type="search" [formControl]="search" placeholder="Cerca per nome del servizio…" />
        </div>
        <div class="result-list">
          <button
            type="button"
            *ngFor="let item of results"
            class="result-item"
            [class.selected]="selected?.id === item.id"
            [disabled]="isLinked(item)"
            (click)="select(item)"
          >
            <span class="line-tile" [ngClass]="areas[lineOf(item.businessLine).area].tone">
              <i class="bi" [ngClass]="lineOf(item.businessLine).icon"></i>
            </span>
            <span class="flex-grow-1 min-w-0">
              <span class="d-block fw-medium text-truncate">{{ item.name }}</span>
              <span class="d-block small text-muted-fh">
                {{ lineOf(item.businessLine).label }} · {{ item.customerType }} · #{{ item.id }}
                <ng-container *ngIf="item.disabled"> · disattivato</ng-container>
              </span>
            </span>
            <span *ngIf="isLinked(item)" class="chip chip-success">Già collegato</span>
            <i *ngIf="selected?.id === item.id" class="bi bi-check-circle-fill text-primary"></i>
          </button>
          <div *ngIf="!searching && !results.length" class="text-center text-muted-fh small py-4">
            Nessun servizio trovato.
          </div>
        </div>
        <div *ngIf="otherCompanyName" class="notice mt-3">
          <i class="bi bi-exclamation-triangle me-1"></i>
          È collegato a <b>{{ otherCompanyName }}</b>: verrà spostato su {{ company.name }}.
        </div>
        <div *ngIf="selected && selected.customerType !== 'B2B'" class="notice mt-3">
          <i class="bi bi-info-circle me-1"></i>
          È un servizio <b>{{ selected.customerType }}</b>, non B2B.
        </div>
      </div>

      <div *ngIf="errorText" class="alert alert-danger small mt-3 mb-0">{{ errorText }}</div>
    </div>

    <div class="fh-modal-foot">
      <span class="hint">Il salvataggio è immediato.</span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-light" (click)="closed.emit()">Annulla</button>
        <button type="button" class="btn btn-primary text-light" [disabled]="saving" (click)="submit()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          {{ isEdit ? 'Salva' : mode === 'link' ? 'Collega' : 'Crea servizio' }}
        </button>
      </div>
    </div>
  </div>
</div>
